import React, { useEffect, useState } from 'react';
import './LoadingBar.css';

interface LoadingBarProps {
  isLoading: boolean;
  duration?: number; // Duration in ms
}

const LoadingBar: React.FC<LoadingBarProps> = ({ isLoading, duration = 1000 }) => {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval>;
    let timeout: ReturnType<typeof setTimeout>;

    if (isLoading) {
      setVisible(true);
      setProgress(0);
      
      // Gradually increase progress
      interval = setInterval(() => {
        setProgress(prev => {
          // Slow down as it approaches 90%
          if (prev < 90) {
            return prev + Math.random() * 10;
          }
          return prev;
        });
      }, duration / 20);
      
      return () => {
        clearInterval(interval);
      };
    } else if (visible) {
      // Complete the progress when loading is done
      setProgress(100);
      
      // Hide the bar after a short delay
      timeout = setTimeout(() => {
        setVisible(false);
      }, 300);
      
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [isLoading, duration, visible]);

  if (!visible) return null;

  return (
    <div className="loading-bar-container">
      <div 
        className="loading-bar" 
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default LoadingBar; 